export default function Collaboration() {
  const aspects = [
    {
      icon: 'ri-team-line',
      title: 'Cross-Functional Teams',
      description: 'We break down silos and encourage collaboration across departments to achieve common goals and drive innovation.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Partnerships',
      description: 'We collaborate with healthcare institutions, research organizations, and industry partners worldwide.'
    },
    {
      icon: 'ri-chat-3-line',
      title: 'Open Communication',
      description: 'We foster transparent communication channels where every voice is heard and valued.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Knowledge Sharing',
      description: 'Regular workshops, training sessions, and mentorship programs promote continuous learning and growth.'
    },
    {
      icon: 'ri-group-line',
      title: 'Team Building',
      description: 'We invest in team-building activities and create opportunities for meaningful connections.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Customer Collaboration',
      description: 'We work closely with healthcare providers to understand needs and deliver tailored solutions.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
            COLLABORATION
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Together We Achieve More
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
            Collaboration is the cornerstone of our success. We believe that the best solutions emerge when diverse minds work together towards a common purpose. Our collaborative culture empowers teams to share knowledge, support each other, and achieve extraordinary results.
          </p>
        </div>

        <div className="mb-16">
          <div className="rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="/assets/CultureCollab.jpg"
              alt="Team Collaboration"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {aspects.map((aspect, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-teal-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl mb-6">
                <i className={`${aspect.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{aspect.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {aspect.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
